import React, { Component } from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames'

import IconButton from '@material-ui/core/IconButton';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import {DatePicker}from 'material-ui-pickers';
import ZoonInIcon from '@material-ui/icons/ZoomIn';
import ZoonOutIcon from '@material-ui/icons/ZoomOut';

import { Document,Page } from 'react-pdf/dist/entry.webpack';
import DragScroll from 'react-dragscroll';



const styles = theme => ({
    button: {
        margin: theme.spacing.unit,
        display:'inline-block',
    },
    buttonWrap:{
        textAlign:'center',
        position:'relative'
    },
    inputArea:{
        position:'relative',
        border:'1px solid #ddd',
        padding:10,
        borderRadius:5,
    },
    pageZooms:{
        textAlign: 'right'
    },
    documentWrapper:{
        backgroundColor:'rgb(40,40,40)'
    },
    textField:{
        width:160,
        marginRight:15
    },
    datePicker : {
        width:150,
    },
    slipPage:{
        width:120
    },

    pdfTitle:{
        display:'inline-block'
    },
    pdfTitleSpan:{
        fontWeight:'bold',
    },
    deleteIcons:{
        position:'absolute',
        left:0,
        top:10
    }

});

class ViewerInner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            scale : 1,
            filePath:props.filePath,
            orgFileName:props.orgFileName,
            pageNumber:props.pageNumber,
            SlipDate:props.SlipDate,
            ShipperCD:props.ShipperCD,
            SlipNO:props.SlipNO,
            SlipPage:props.SlipPage,
            IsDelete:props.IsDelete,
            errors:{
                ShipperCD:false,
                SlipNO:false,
                SlipPage:false
            }
        };
    }



    UNSAFE_componentWillReceiveProps(nextProps) {
        if(nextProps.filePath !== this.state.filePath){
            this.setState({
                scale : 1,
                filePath:nextProps.filePath,
                orgFileName:nextProps.orgFileName,
                pageNumber:nextProps.pageNumber,
                SlipDate:nextProps.SlipDate,
                ShipperCD:nextProps.ShipperCD,
                SlipNO:nextProps.SlipNO,
                SlipPage:nextProps.SlipPage,
                IsDelete:nextProps.IsDelete
            });

            this.error_checks("ShipperCD",nextProps.ShipperCD);
            this.error_checks("SlipNO",nextProps.SlipNO);
            this.error_checks("SlipPage",nextProps.SlipPage);
            if(!nextProps.IsDelete){
                this.SlipDate.focus();
            }

        }
        else if (nextProps.SlipDate !== this.state.SlipDate) {
            this.setState({
                SlipDate:nextProps.SlipDate
            });
        }
        else if(nextProps.ShipperCD !== this.state.ShipperCD){
            this.setState({
                ShipperCD:nextProps.ShipperCD
            });
        }
        else if(nextProps.SlipNO !== this.state.SlipNO){
            this.setState({
                SlipNO:nextProps.SlipNO
            });
        }
        else if(nextProps.SlipPage !== this.state.SlipPage){
            this.setState({
                SlipPage:nextProps.SlipPage
            });
        }
        else if(nextProps.IsDelete !== this.state.IsDelete){
            this.setState({
                IsDelete:nextProps.IsDelete
            });
        }

    }


    handleClickZoomIn = () =>{
        const scale = this.state.scale;

        if(scale > 3) return;

        this.setState({
            scale:scale + 0.5
        })
    };

    handleClickZoomOut = () =>{
        const scale = this.state.scale;

        if(scale === 1) return;

        this.setState({
            scale:scale - 0.5
        })
    };

    handleSlipDateChange = date => {
        if(this.props.changeDataFunc) this.props.changeDataFunc('SlipDate',date,this.state.errors);
    };
    handleSlipDateInputChange = (e) =>{
        if(!e.target.value) {
            if(this.props.changeDataFunc) this.props.changeDataFunc('SlipDate',null,this.state.errors);
        }
    };

    handleChange = event => {

        this.error_checks(event.target.name,event.target.value);

        if(this.props.changeDataFunc) this.props.changeDataFunc(event.target.name,event.target.value,this.state.errors);

    };

    handleChangeCheck = event =>{
        if(this.props.changeDataFunc) this.props.changeDataFunc('IsDelete',!this.props.IsDelete,this.state.errors);
    };

    handleKeyPress = event =>{
        if(event.key !== 'Enter'){
            return
        }
        switch (event.target.name) {

            case 'SlipDate':
                this.SlipNO.focus();
                break;
            case 'SlipNO':
                this.ShipperCD.focus();
                break;
            case 'ShipperCD':
                this.SlipPage.focus();
                break;
            case 'SlipPage':
                this.SlipDate.focus();
                break;
            default:
                break;
        }
    };


    error_checks = (key,value) =>{
        let errors = this.state.errors;
        let reg;
        switch (key) {
            case 'ShipperCD':
            case 'SlipNO':
                reg = new RegExp(/^[0-9a-zA-Z]*$/);
                break;
            case 'SlipPage':
                reg = new RegExp(/^[0-9]*$/);
                break;
            default:
                break;
        }
        errors[key] = !(reg.test(value));

        this.setState({
            errors
        });
    };



    render() {
        const {scale,filePath,orgFileName,pageNumber,ShipperCD,SlipDate,SlipNO,SlipPage,IsDelete,errors} = this.state;
        const {classes} = this.props;
        const height = (this.props.navigation.windowHeight * 0.55);
        const width = (this.props.navigation.windowWidth * 0.7);

        return (
            <div className="pdf_inner2">
                <div>
                    <p className={classes.pdfTitle}>
                        対象ページ : <span className={classes.pdfTitleSpan}>{orgFileName}({pageNumber}ページ目)</span>
                    </p>
                </div>
                <DragScroll width={width} height={height} className={"pdf_document_wrapper"}>
                    <Document
                        file={filePath}
                        options={{
                            cMapUrl: './data/cmaps/',
                            cMapPacked: true,
                        }}
                    >
                        <Page
                            pageNumber={1}
                            width={width}
                            scale={scale}
                            className={"pdf_viewer_page"}
                        />
                    </Document>
                </DragScroll>
                <div className={classes.buttonWrap}>
                    <div className={classes.pageZooms}>
                        <IconButton className={classes.button} aria-label="Last" onClick={this.handleClickZoomIn}>
                            <ZoonInIcon />
                        </IconButton>

                        <IconButton className={classes.button} aria-label="Last" onClick={this.handleClickZoomOut}>
                            <ZoonOutIcon />
                        </IconButton>
                    </div>
                    <div className={classes.deleteIcons}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={IsDelete}
                                    onChange={this.handleChangeCheck}
                                    value={"IsDelete"}
                                    color="primary"
                                    name="IsDelete"
                                />
                            }
                            label="このページは破棄する"
                        />
                    </div>
                </div>
                <div className={classes.inputArea}>
                    <DatePicker
                        disabled={IsDelete}
                        keyboard
                        label="伝票日付"
                        maxDateMessage="Date must be less than today"
                        value={SlipDate}
                        onChange={this.handleSlipDateChange}
                        onInputChange={this.handleSlipDateInputChange}
                        format="YYYY/MM/DD"
                        className={classNames(classes.textField,classes.datePicker)}
                        invalidDateMessage="日付が正しくありません"
                        cancelLabel={"キャンセル"}
                        inputRef={field => this.SlipDate = field}
                        name="SlipDate"
                        onKeyPress={this.handleKeyPress}
                        autoFocus={true}
                    />
                    <TextField
                        error={errors.SlipNO && !IsDelete}
                        disabled={IsDelete}
                        label="伝票No."
                        placeholder="伝票No."
                        className={classes.textField}
                        onKeyPress={this.handleKeyPress}
                        onChange={this.handleChange}
                        name="SlipNO"
                        inputRef={field => this.SlipNO = field}
                        inputProps={{
                            maxLength:10
                        }}
                        value={SlipNO}
                        helperText={(errors.SlipNO && !IsDelete) ? "半角英数で入力してください" : null}
                    />
                    <TextField
                        error={errors.ShipperCD && !IsDelete}
                        disabled={IsDelete}
                        label="メーカーNo."
                        placeholder="メーカーNo."
                        className={classes.textField}
                        onKeyPress={this.handleKeyPress}
                        onChange={this.handleChange}
                        name="ShipperCD"
                        value={ShipperCD}
                        inputRef={field => this.ShipperCD = field}
                        inputProps={{
                            maxLength:10
                        }}
                        helperText={(errors.ShipperCD && !IsDelete) ? "半角英数で入力してください" : null}
                    />
                    <TextField
                        error={errors.SlipPage && !IsDelete}
                        disabled={IsDelete}
                        label="伝票ページ番号"
                        placeholder="伝票ページ番号"
                        className={classNames(classes.textField,classes.slipPage)}
                        onKeyPress={this.handleKeyPress}
                        onChange={this.handleChange}
                        name="SlipPage"
                        inputRef={field => this.SlipPage = field}
                        inputProps={{
                            maxLength:4
                        }}
                        value={SlipPage}
                        helperText={(errors.SlipPage && !IsDelete) ? "半角整数で入力してください" : null}
                    />
                </div>
            </div>
        );
    }
}
ViewerInner.propTypes = {
    filePath:PropTypes.string,
    orgFileName:PropTypes.string,
    pageNumber:PropTypes.number,
    slipDate:PropTypes.object,
    shipperCD:PropTypes.string,
    slipNO:PropTypes.string,
    slipPage:PropTypes.string,
    isDelete:PropTypes.bool,
    changeDataFunc:PropTypes.func,
};
ViewerInner.defaultProps = {
    filePath:null,
    orgFileName:null,
    pageNumber:null,
    slipDate:null,
    shipperCD:'',
    slipNO:'',
    slipPage:'',
    isDelete:false
};
function mapStateToProps(state) {
    return {
        navigation : state.navigation
    };
}
export default compose(
    withStyles(styles),
    connect(mapStateToProps)
)(ViewerInner);


// WEBPACK FOOTER //
// ./src/routes/upload-receipt/components/viewer-inner.js